<template>
  <div class="login">
    <form class="container" @submit.prevent="login" :class="error?'error':token?'success':''">
      <svg viewBox="0 0 320 300">
        <defs>
          <linearGradient
            inkscape:collect="always"
            id="linearGradient"
            x1="13"
            y1="193.49992"
            x2="307"
            y2="193.49992"
            gradientUnits="userSpaceOnUse">
            <stop
              :style="`stop-color:${stateColor}`"
              offset="0"
              id="stop876" />
            <stop
              :style="`stop-color:${stateColor}`"
              offset="1"
              id="stop878" />
          </linearGradient>
        </defs>
        <path d="m 40,120.00016 239.99984,-3.2e-4 c 0,0 24.99263,0.79932 25.00016,35.00016 0.008,34.20084 -25.00016,35 -25.00016,35 h -239.99984 c 0,-0.0205 -25,4.01348 -25,38.5 0,34.48652 25,38.5 25,38.5 h 215 c 0,0 20,-0.99604 20,-25 0,-24.00396 -20,-25 -20,-25 h -190 c 0,0 -20,1.71033 -20,25 0,24.00396 20,25 20,25 h 168.57143" />
      </svg>
      <div class="form">
        <label for="email">{{$t('account.username')}}</label>
        <input class="username" type="text" v-model="username" placeholder="大壮">
        <label for="password">{{$t('account.password')}}</label>
        <input class="password" type="password" v-model="password" placeholder="246810">
        <div class="remember">
          <input type="checkbox" v-model="isRemembered">
          <label>{{$t('account.remember')}}</label>
        </div>
        <input class="submit" type="submit"
          :value="$t('account.login')"
          :disabled="isAuthenticating">
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import anime from 'animejs'

export default {
  components: {
  },
  data () {
    return {
      username: '',
      password: ''
    }
  },
  computed: {
    isRemembered: {
      get () {
        return this.$store.state.config.bAuthRemember
      },
      set (newValue) {
        this.toggleAuthRemember(newValue)
      }
    },
    isAuthenticating () {
      return this.$store.state.pending.auth
    },
    error () {
      return this.$store.state.error.auth
    },
    token () {
      return this.$store.state.auth.token
    },
    stateColor () {
      const color = this.error ? 'red' : this.token ? 'green' : '#3D91F7'
      return color
    }
  },
  methods: {
    ...mapActions([
      'authenticate'
    ]),
    ...mapMutations([
      'toggleAuthRemember'
    ]),
    login () {
      if (!this.isAuthenticating) {
        this.authenticate({
          data: {
            password: this.password,
            username: this.username
          }
        })
      }
    }
  },
  mounted () {
    let current = null
    document.querySelector('.username').addEventListener('focus', function (e) {
      if (current) current.pause()
      current = anime({
        targets: 'path',
        strokeDashoffset: {
          value: 0,
          duration: 700,
          easing: 'easeOutQuart'
        },
        strokeDasharray: {
          value: '240 1386',
          duration: 700,
          easing: 'easeOutQuart'
        }
      })
    })
    document.querySelector('.password').addEventListener('focus', function (e) {
      if (current) current.pause()
      current = anime({
        targets: 'path',
        strokeDashoffset: {
          value: -336,
          duration: 700,
          easing: 'easeOutQuart'
        },
        strokeDasharray: {
          value: '240 1386',
          duration: 700,
          easing: 'easeOutQuart'
        }
      })
    })
    document.querySelector('.submit').addEventListener('focus', function (e) {
      if (current) current.pause()
      current = anime({
        targets: 'path',
        strokeDashoffset: {
          value: -730,
          duration: 700,
          easing: 'easeOutQuart'
        },
        strokeDasharray: {
          value: '530 1386',
          duration: 700,
          easing: 'easeOutQuart'
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/color.scss';
@import '@/stylesheets/function.scss';

//fonts
// $font_0: 'Inter UI';
$font_1: sans-serif;

//urls
$url_1: url(#linearGradient);

::selection {
  background: $color_bleu_de_france;
}
.login {
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.container {
  display: flex;
  height: 20rem;
  margin: 0 auto;

  // background: $color_bleu_de_france;
  background: white;
  // border: solid rem(1) $color_bleu_de_france;
  //Instead of the line below you could use @include box-shadow($shadow-1, $shadow-2, $shadow-3, $shadow-4, $shadow-5, $shadow-6, $shadow-7, $shadow-8, $shadow-9, $shadow-10)
  transition: box-shadow 1s ease;
  box-shadow: 0 0 rem(40) 1rem rgba($color_bleu_de_france, .3);
  border-radius: rem(5);
  color: $color_seashell_approx;
  position: relative;
  width: 20rem;
  &.error {
    box-shadow: 0 0 rem(40) 1rem rgba(red, .3);
  }
  &.success {
    box-shadow: 0 0 rem(40) 1rem rgba(green, .3);
  }
}
svg {
  position: absolute;
  width: 20rem;
}
path {
  fill: none;
  stroke: $url_1;
  stroke-width: 4;
  stroke-dasharray: 240 1386;
}
.form {
  margin: rem(40);
  position: absolute;
}
label {
  color: $color_silver_sand_approx;
  display: block;
  font-size: rem(14);
  height: 1rem;
  margin-top: rem(20);
  margin-bottom: rem(5);
  text-align: left;
}
input {
  background: transparent;
  border: 0;
  color: $color_dove_gray_approx;
  font-size: rem(20);
  height: rem(30);
  line-height: rem(30);
  outline: none !important;
  width: 100%;
  &::placeholder {
    color: $color_silver_sand_approx;
  }
}
input::-moz-focus-inner {
  border: 0;
}
.remember {
  position: absolute;
  left: 75%;
  bottom: 45%;
  width: auto;
  input {
    width: 1rem;
    height: 1rem !important;
  }
  label, input {
    height: 1.5rem;
    padding: 0;
    margin: 0;
    display: inline-block;
  }
}
.submit {
  color: $color_dove_gray_approx;
  margin-top: rem(40);
  //Instead of the line below you could use @include transition($transition-1, $transition-2, $transition-3, $transition-4, $transition-5, $transition-6, $transition-7, $transition-8, $transition-9, $transition-10)
  transition: color 300ms;
  &:focus {
    color: black;
  }
  &:active {
    color: $color_celeste_approx;
  }
  &:disabled {
    color: $color_celeste_approx;
  }
}
</style>
